import { toggleMenu } from "./header";
import { scrollToHash, getSamePageAnchor } from "./smooth-scrolling";
import '../css/main.css';
import { initSingleProductTabs } from './single-product';
import { initOrganicTransformationTabs } from './organic-transformation-tabs';
import { initFaqAccordion } from './faq-accordion';

document.addEventListener("DOMContentLoaded", () => {
  /**
   * Toggle del header
   */
  toggleMenu()

  /**
   * Example carousel import
   */
  const carousel = document.querySelectorAll(".carousel");
  if (carousel.length > 0) {
    import("./carousel").then((module) => {
      carousel.forEach((slider) => {
        const carouselId = slider.id;
        if (carouselId) {
          const controlsSelector = `#${carouselId}-controls`;
          const controlsElement = document.querySelector(controlsSelector);
          if (controlsElement) {
            module.carousel(slider, controlsSelector);
          } else {
            console.warn(`Controls element not found for carousel: ${carouselId}`);
            // Initialize without controls or with default selector
            module.carousel(slider);
          }
        } else {
          console.warn('Carousel element missing ID, using default controls');
          module.carousel(slider);
        }
      });
    });
  }

  const introCarousel = document.querySelectorAll(".intro-carousel");
  if (introCarousel.length > 0) {
    import("./intro").then((module) => {
      introCarousel.forEach((slider) => {
        module.carousel(slider);
      });
    });
  }

  /**
   * Carrusel especial para 3 items (Compost)
   */
  const carouselesEspeciales = document.querySelectorAll(".carousel2");
  if (carouselesEspeciales.length > 0) {
    import("./carousel2").then((module) => {
      carouselesEspeciales.forEach((slider) => {
        module.carousel2(slider);
      });
    });
  }

  /**
   * Carrusel de 4 items (Features)
   */
  const carouselesFeatures = document.querySelectorAll(".carousel3");
  if (carouselesFeatures.length > 0) {
    import("./carousel3").then((module) => {
      carouselesFeatures.forEach((slider) => {
        module.carousel3(slider);
      });
    });
  }

  const industrialProductsCarousels = document.querySelectorAll(".industrial-products-carousel");
  if (industrialProductsCarousels.length > 0) {
    import("./industrial-products-carousel").then((module) => {
      industrialProductsCarousels.forEach((slider) => {
        module.initIndustrialProductsCarousel(slider);
      });
    });
  }

  const industrialFaqs = document.querySelectorAll('[data-industrial-faq]');
  if (industrialFaqs.length > 0) {
    import('./industrial-faq-accordion').then((module) => {
      industrialFaqs.forEach((faq) => module.initIndustrialFaq(faq));
    });
  }


  /**
   * Smooth scrolling support
   */
  // If a link's href is within the current page, scroll to it instead
  document.querySelectorAll('a[href]').forEach(a => {
    a.addEventListener('click', e => {
      scrollToHash(getSamePageAnchor(a), e);
    });
  });
  // Scroll to the element in the URL's hash on load
  scrollToHash(window.location.hash);

  /**
   * ACF7 event listener
   */
  document.addEventListener('wpcf7mailsent', (event) => {
    gtag('event', 'Formulario', {
      'event_category': event.detail.contactFormId,
      'event_label': event.detail.unitTag
    });
  }, false);

  /**
   * Handle archive breadcrumb
   */
  const archiveBreadcrumb = document.querySelectorAll("#archiveBreadcrumb");
  if (archiveBreadcrumb.length > 0) {
    import("./breadcrumb").then((module) => {
      archiveBreadcrumb.forEach((breadcrumb) => {
        module.handleBreadcumb(breadcrumb);
      });
    });
  }

  /**
   * Single product
   */
  // const singleProductContainer = document.querySelector('.single-product-details');
  // if (singleProductContainer) {
  //   import('./single-product-slider').then((module) => {
  //     module.carousel();
  //   });
  // }

  /**
   * Single product
   */
  const singleProductModal = document.querySelector('#promosModal');
  if (singleProductModal) {
    import('./single-product-modal').then((module) => {
      module.handleModal();
    });
  }

  const postCodeForm = document.querySelector('#postCodeForm');
  if (postCodeForm) {
    import('./post-code').then((module) => {
      module.handleShippingCostCalculator(postCodeForm);
    });
  }

  const accordions = document.querySelectorAll(".accordion");
  if (accordions.length > 0) {
    import("./accordions").then((module) => {
      accordions.forEach((accordion) => {
        module.handleAccordion(accordion);
      });
    });
  }

  const wooCheckout = document.querySelector('.woocommerce-checkout.woocommerce-page');
  if (wooCheckout) {
    import('./checkout').then((module) => {
      module.handleZipCodeCheckout();
    });
  }

  const refLink = document.querySelector('#refLink');
  if (refLink) {
    const refLinkBtn = document.querySelector('#refLinkBtn');
    refLinkBtn.addEventListener('click', () => {
      navigator.clipboard.writeText(refLink.innerText);
    });
  }

  const toggleLogin = document.querySelector('#toggleLogin');
  const toggleRegistration = document.querySelector('#toggleRegistration');
  const loginForm = document.querySelector('.u-column1.col-1');
  const registerForm = document.querySelector('.u-column2.col-2');
  if (toggleLogin) {
    toggleLogin.addEventListener('click', () => {
      loginForm.classList.remove('hidden');
      registerForm.classList.add('hidden');
    });
  }
  if (toggleRegistration) {
    toggleRegistration.addEventListener('click', () => {
      loginForm.classList.add('hidden');
      registerForm.classList.remove('hidden');
    });
  }
});


document.addEventListener('DOMContentLoaded', () => {
  initSingleProductTabs();
  initOrganicTransformationTabs();
  initFaqAccordion();
});
